module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lower-subpanel-wrap"
  }, [_vm._t("button-1", [_vm._m(0)]), _vm._t("button-2", [_vm._m(1)]), _vm._t("button-3", [_vm._m(2)]), _vm._t("button-4", [_vm._m(3)]), _vm._t("button-5", [_vm._m(4)]), _vm._t("button-6", [_vm._m(5)]), _vm._t("button-7", [_vm._m(6)]), _vm._t("button-8", [_vm._m(7)]), _vm._t("button-9", [_vm._m(8)])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn control-button control-button-red button-transparent"
  }, [_c('div', {
    staticClass: "button-inside-wrap"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn control-button control-button-red button-transparent"
  }, [_c('div', {
    staticClass: "button-inside-wrap"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn control-button control-button-red button-transparent"
  }, [_c('div', {
    staticClass: "button-inside-wrap"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn control-button control-button-red button-transparent"
  }, [_c('div', {
    staticClass: "button-inside-wrap"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn control-button control-button-red button-transparent"
  }, [_c('div', {
    staticClass: "button-inside-wrap"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn control-button control-button-red button-transparent"
  }, [_c('div', {
    staticClass: "button-inside-wrap"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn control-button control-button-red button-transparent"
  }, [_c('div', {
    staticClass: "button-inside-wrap"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn control-button control-button-red button-transparent"
  }, [_c('div', {
    staticClass: "button-inside-wrap"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn control-button control-button-red button-transparent"
  }, [_c('div', {
    staticClass: "button-inside-wrap"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b336ef0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/BottomButtons.vue
// module id = 1483
// module chunks = 1